import SubcategoryPage from '@/components/template/SubcategoryPage';

const IndexCeilingLights = () => {
  const products = [
    {
      title: "Index Ceiling Model 1",
      imageSrc: "https://images.unsplash.com/photo-1544965838-54ef8406f868?auto=format&fit=crop&q=80",
      url: "/svetila/index-ceiling/model-1"
    },
    {
      title: "Index Ceiling Model 2",
      imageSrc: "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?auto=format&fit=crop&q=80",
      url: "/svetila/index-ceiling/model-2"
    },
    {
      title: "Index Ceiling Model 3",
      imageSrc: "https://images.unsplash.com/photo-1524484485831-a92ffc0de03f?auto=format&fit=crop&q=80",
      url: "/svetila/index-ceiling/model-3"
    },
    {
      title: "Index Ceiling Model 4",
      imageSrc: "https://images.unsplash.com/photo-1507652955-f3dcef5a3be5?auto=format&fit=crop&q=80",
      url: "/svetila/index-ceiling/model-4"
    }
  ];

  return (
    <SubcategoryPage
      title="Index Ceiling Lights"
      description="Sodobne stropne svetilke, ki združujejo minimalističen dizajn in maksimalno funkcionalnost. Idealna izbira za sodobne kopalnice."
      heroImage="https://images.unsplash.com/photo-1544965838-54ef8406f868?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default IndexCeilingLights;